import { EffectReducer } from 'use-effect-reducer'

import { RefundEffect, RefundEvent, RefundState } from './types'

export const refundStateReducer: EffectReducer<
  RefundState,
  RefundEvent,
  RefundEffect
> = (state, event, exec) => {
  switch (event.type) {
    case 'COMPLETE_REFUND': {
      return {
        status: 'done',
      }
    }
    case 'RETRY': {
      // retry disabled ? do nothing
      if (!state.retryable || state.status !== 'error') return state

      const previousState = state.previousState
      const effect: RefundEffect = { type: 'ecomRefundEffect' }

      exec(effect)

      return previousState
    }
    case 'ERROR': {
      return {
        status: 'error',
        errorMessage: event.errorMessage,
        retryable: event.retryable,
        previousState: state,
      }
    }
    default: {
      // This `never` typing will let us know at compile time if we do not handle an existing event type. Neat !
      const _exhaustiveCheck: never = event
      return _exhaustiveCheck
    }
  }
}
